export default __webpack_public_path__ + "static/media/80fd0e3a7d0417e1ca6ada4206ad8eb2.png";